export const portfolioCharts = {
    xSelect1: 'スコア（技術の進展度）',
    ySelect1: '市場期待値',
    yAxisUnit: '(10億円)',
    labelArrayOverFlowMsg: '最大5つのラベルまで表示可能です'
}
